'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.animationFrame = void 0;
var animationFrame = function () {
    return new Promise(function (resolve) {
        requestAnimationFrame(function (timeStamp) {
            resolve(timeStamp);
        });
    });
};
exports.animationFrame = animationFrame;
